import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import config from '../../config';
import { headers } from "../../token";
import DeletedMetal from "./DeleteMetal";
import UpdateMetal from "./UpdateMetal";
import vAdminformat from "../../adminFormat";

const server_backend = config.API_URL;

const Metal = ({ username }) => {
    const [MetalList, setMetalList] = useState([]);
    const [isUpdating, setIsUpdating] = useState(false);
    const [onMetalID, setOnMetalID] = useState(0);
    const [filtersEnabled, setFiltersEnabled] = useState(false);
    const [filterBy, setFilterBy] = useState("name");
    const [filterStatus, setFilterStatus] = useState(0);
    const [filterValue, setFilterValue] = useState(null);
    const [selectedFilter, setSelectedFilter] = useState("");

    useEffect(() => {
        const getMetal = async () => {
            try {
                const response = await axios.get(`${server_backend}/materials/types/list`, headers);

                if (response.data.RES_CODE === "00") {
                    setMetalList(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log("Unexpected error, please check")
            }
        }
        getMetal();
    }, []);

    const ShowModalUpdate = () => {
        setIsUpdating(true);
    }

    const CloseModal = () => {
        setIsUpdating(false);
    }

    const getMetal = async () => {
        try {
            const response = await axios.get(`${server_backend}/materials/types/list`, headers);

            if (response.data.RES_CODE === "00") {
                setMetalList(response.data.RES_RESULT);
            }
        } catch (error) {
            console.log("Unexpected error, please check")
        }
    }

    const handleFiltersToggle = () => {
        setFiltersEnabled(!filtersEnabled);
    };

    const handleFilterByChange = (e) => {
        setFilterBy(e.target.value);
        const value = e.target.value;
        FilterMetal(value);
    };

    const handleFilterStatusChange = (e) => {
        setFilterStatus(e.target.value);
    };

    const handleFilterValueChange = (e) => {
        setFilterValue(e.target.value);

        if (filtersEnabled) {
            FilterMetal();
        }
    };


    const handleColumnClick = (filterValue) => {
        if (filtersEnabled) {
            setSelectedFilter(filterValue);
            handleFilterByChange({ target: { value: filterValue } });
        }

    };

    const FilterMetal = async () => {
        try {
            const response = await axios.get(`${server_backend}/materials/types/search?user_transaction=${username}&findby=${filterBy}&findfor=${filterValue}&est_id=${filterStatus}`, headers);
            setMetalList(response.data.RES_RESULT);
        } catch (error) {
            console.log("Unexpected error, please check")
        }
    };

    useEffect(() => {
        if (filtersEnabled) {
            FilterMetal();
        }
    }, [filterBy, filterStatus, filterValue]);

    return (
        <div className="page-content" data-simplebar-track="secondary" data-simplebar="init" style={{ overflow: "auto" }}>
            <div className="container-fluid">
                {!isUpdating ? (
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <h4 className="mb-sm-0">Material type List</h4>
                                <div className="page-title-right">
                                    <ol className="breadcrumb m-0">
                                        <li className="breadcrumb-item"><a href="javascript: void(0);">Material type</a></li>
                                        <li className="breadcrumb-item active">Material type List</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <UpdateMetal username={username} onMetalID={onMetalID} onClose={CloseModal} getMetal={getMetal} />
                )}

                {!isUpdating && (
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card" id="tasksList">
                                <div className="card-header border-0">
                                    <div className="d-flex align-items-center">
                                        <h5 className="card-title mb-0 flex-grow-1">All Material type</h5>
                                        <div className="col-xxl-1 col-sm-2" style={{ paddingRight: "2px" }}>
                                            <button type="button" className="btn btn-primary w-100" onClick={handleFiltersToggle}>
                                                <i className="ri-equalizer-fill me-1 align-bottom"></i> Filters
                                            </button>
                                        </div>
                                        <div className="flex-shrink-0">
                                            <Link className="btn btn-danger add-btn" to="/create-metal-types">
                                                <i className="ri-add-line align-bottom me-1"></i> Create
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                {filtersEnabled && (
                                    <div className="card-body border border-dashed border-end-0 border-start-0">
                                        <div className="row g-3">
                                            <div className="col-4">
                                                <div className="input-light">
                                                    <select
                                                        className="form-control custom-select-style"
                                                        name="choices-single-default"
                                                        disabled={!filtersEnabled}
                                                        value={filterBy} // Cambiar a filterBy
                                                        onChange={handleFilterByChange}
                                                    >
                                                        <option value="">Filter by</option>
                                                        <option value="matt_ID">ID</option>
                                                        <option value="name">Name</option>
                                                        <option value="comment">Code</option>
                                                    </select>

                                                </div>
                                            </div>
                                            <div className="col-4">
                                                <div className="input-light">
                                                    <select
                                                        className="form-control custom-select-style"
                                                        data-choices
                                                        data-choices-search-false
                                                        name="choices-single-default"
                                                        id="idFilterStatus"
                                                        disabled={!filtersEnabled}
                                                        onChange={handleFilterStatusChange}
                                                    >
                                                        <option value={0}>Filter status</option>
                                                        <option value={1}>ACTIVATED</option>
                                                        <option value={2}>DISABLED</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                <div className="search-box">
                                                    <input
                                                        type="text"
                                                        className="form-control search"
                                                        placeholder="Search for tasks or something..."
                                                        disabled={!filtersEnabled}
                                                        onChange={handleFilterValueChange}
                                                    />
                                                    <i className="ri-search-line search-icon"></i>
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                )}

                                <div className="card-body">
                                    <div
                                        className="table-responsive table-card mb-4"
                                        style={{ minHeight: "60vh", display: "flex", flexDirection: "column" }}
                                    >
                                        <table className="table align-middle table-nowrap mb-0" id="tasksTable">
                                            <thead className="table-light text-muted">
                                                <tr>
                                                    <th className="th-hover" onClick={() => handleColumnClick("matt_ID")}>ID</th>
                                                    <th className="th-hover" onClick={() => handleColumnClick("name")}>Name</th>
                                                    <th className="th-hover" onClick={() => handleColumnClick("name")}>Code</th>
                                                    <th className="th-hover" onClick={() => handleColumnClick("lastprice")}>Last Price (GBP / Unit)</th>
                                                    <th className="th-hover" onClick={() => handleColumnClick("lastprice")}>Last Update</th>
                                                    <th className="th-hover" onClick={() => handleColumnClick("status")}>Status</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>

                                            <tbody className="list form-check-all">
                                                {MetalList.map((Metal_L) => (
                                                    <tr key={Metal_L.matt_ID}>
                                                        <th scope="row">
                                                            <div className="form-check">
                                                                {Metal_L.matt_ID}
                                                            </div>
                                                        </th>

                                                        <td className="due_date">{Metal_L.name}</td>
                                                        <td className="due_date">{Metal_L.comment}</td>
                                                        <td className="due_date">{Metal_L.lastprice}</td>
                                                        <td className="date_lastprice">{vAdminformat.FormatDateTime(Metal_L.date_lastprice)}</td>
                                                        <td className="status">
                                                            <span className={`${Metal_L.status_name === 'ACTIVATED' ? "badge badge-soft-success" : "badge badge-soft-danger"} text-uppercase`}>
                                                                {Metal_L.status_name}
                                                            </span>
                                                        </td>
                                                        <td className="due_date">
                                                            <ul className="list-inline hstack gap-2 mb-0">
                                                                <li className="list-inline-item edit">
                                                                    <Link
                                                                        type="button"
                                                                        onClick={() => {
                                                                            ShowModalUpdate();
                                                                            setOnMetalID(Metal_L.matt_ID);
                                                                        }}
                                                                        className="text-primary d-inline-block edit-item-btn"
                                                                    >
                                                                        <i className="ri-pencil-fill fs-16"></i>
                                                                    </Link>
                                                                </li>
                                                                <li className="list-inline-item" >
                                                                    <Link className="text-danger d-inline-block remove-item-btn" onClick={() => {
                                                                        DeletedMetal(Metal_L.matt_ID, username, getMetal)
                                                                    }}>
                                                                        <i className="ri-delete-bin-5-fill fs-16"></i>
                                                                    </Link>
                                                                </li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="row g-0 text-center text-sm-start">
                                        <div className="col-sm-6">
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="pagination-block pagination pagination-separated justify-content-center justify-content-sm-end mb-sm-0">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Metal;
